module.exports = __webpack_public_path__ + "img/money_header.b323fe5c.svg";